export const SELECT_ALL = "All";
export const lOGIN_BANNER = "https://static.wixstatic.com/media/f1b2b3_70033c669b974ac6abb023dab1213c26~mv2.jpg/v1/fill/w_1024,h_1024,al_c,q_85,enc_auto/f1b2b3_70033c669b974ac6abb023dab1213c26~mv2.jpg";

export const COLUMN_NAME = "column_name"



